import { Link, List, ListItem, Typography } from '@mui/material'
import { useI18n } from '@ggs/i18n'
import { Search211Record } from '../../../definitions'
import { isEmpty } from 'lodash'
import {
  formatEmail,
  formatPhone,
  formatUrl,
  detailPath,
  directionsUrl,
} from '../../../local/utils'

// eslint-disable-next-line valid-jsdoc

/**
 * @typedef {Object} SearchResultPopupProps
 * @property {Search211Record} record
 * @property {string} distance
 */

/**
 * Search result popup for maps.
 * @param {SearchResultPopupProps} props
 * @return {JSX.Element}
 */
const SearchResultPopup = ({ record, distance }) => {
  const { t } = useI18n()

  return (
    <div className={'place-details'}>
      <Typography>{distance}</Typography>
      <div className={'place-division'} />
      {!isEmpty(record.PhoneNumbers) && (
        <Typography>{t('T: ')} {formatPhone(record.PhoneNumbers)}</Typography>
      )}
      {!isEmpty(record.Email) && (
        <Typography>
          {t('E: ')}
          <Link href={formatEmail(record.Email)} target="_blank" rel="noreferrer">
            {record.Email}
          </Link>
        </Typography>
      )}
      {!isEmpty(record.Website) && (
        <Typography>
          <Link href={formatUrl(record.Website)} target="_blank" rel="noreferrer">
            {t('Visit Website')}
          </Link>
        </Typography>
      )}
      <List style={{ display: 'flex', flexDirection: 'row' }}>
        <ListItem className="place-details__listing-item">
          <Link href={detailPath(record.id)}>
            {t('View Listing')}
          </Link>
        </ListItem>
        <ListItem>
          <Link
            href={directionsUrl(record.Latitude, record.Longitude)}
            target="_blank"
            rel="noreferrer"
          >
            {t('Directions')}
          </Link>
        </ListItem>
      </List>
    </div>
  )
}

export default SearchResultPopup
